import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { Checkbox, ICheckboxProps } from '@fluentui/react';

interface IIAICheckboxField extends ICheckboxProps {
    name: string;
}

const IAICheckboxField: React.FunctionComponent<IIAICheckboxField> = ({
    name,
    ...other
}) => {
    const {
        control
    } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                return (
                <Checkbox
                    checked={field.value}
                    {...field}
                    {...other}
                />
            ) }}
        />
    );
}

export default IAICheckboxField;